import { render } from "./updateCustomer.vue?vue&type=template&id=2bcc2275&scoped=true"
import script from "./updateCustomer.vue?vue&type=script&lang=js"
export * from "./updateCustomer.vue?vue&type=script&lang=js"

import "./updateCustomer.vue?vue&type=style&index=0&id=2bcc2275&lang=less&scoped=true"

import exportComponent from "D:\\New Git\\tl-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bcc2275"]])

export default __exports__